/* istanbul ignore file */

import { useEffect } from 'react';
var SCREEN_EDGE_PX = 10;
export var usePreventSwipeNavigation = function usePreventSwipeNavigation(ref) {
  useEffect(function () {
    var currentRef = ref.current;
    var onTouchStart = function onTouchStart(e) {
      var pageX = e.touches[0].pageX;
      if (pageX < SCREEN_EDGE_PX || pageX > window.innerWidth - SCREEN_EDGE_PX) {
        e.preventDefault();
      }
    };
    currentRef === null || currentRef === void 0 || currentRef.addEventListener('touchstart', onTouchStart);
    return function () {
      return currentRef === null || currentRef === void 0 ? void 0 : currentRef.removeEventListener('touchstart', onTouchStart);
    };
  }, [ref]);
};